"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolRoute = void 0;
exports.ToolRoute = {
    Cut: 'cut',
    Fracture: 'fracture',
    Growth: 'growth',
    Labels: 'labels',
    Pain: 'pain',
    Pen: 'pen',
    Sketch: 'sketch',
    Spurs: 'spurs',
    Text: 'text',
    VideoHint: 'video-hint',
};
